import $ from 'jquery';

export const focus = ($modal) => {
    $modal.find('input:visible').first().focus();
};
export const onOpen = ($modal) => {
    var $parent = $modal.parent();

    // append to body
    // $modal.appendTo('body');

    // keep parent ref
    $modal.data('parent', $parent);
};
export const onClose = ($modal) => {
    // var $parent = $modal.data('parent');

    // append to original parent
    // $modal.appendTo($parent);

    // pause videos
    pauseVideo($modal);
};
export const pauseVideo = ($modal) => {
    $modal.find('video').each(function() {
        $(this)[0].pause();
    });
};
export const restartSlider = ($modal) => {
    var $cycle = $modal.find('.slider__cycle'),
        $dots = $modal.find('.slick-dots');

    // if ($dots.length) {
    //     $dots.first().remove();
    // }

    if ($cycle.length) {
        $cycle.slick('resize');
    }
};
export const binds = () => {
    // ---------------- modal hack
    $('body').on('show.bs.modal', '.modal', function() {
        onOpen($(this));
    });
    $('body').on('shown.bs.modal', '.modal', function() {
        restartSlider($(this));
    });
    $('body').on('hidden.bs.modal', '.modal', function() {
        onClose($(this));
    });
};
